import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import JsonLd from '@/components/base/JsonLd';
import usePageMeta from '@/hooks/usePageMeta';
import { faqs } from '@/mocks/news';
import HeroSection from './components/HeroSection';
import HeatRanking from './components/HeatRanking';
import CategoryGrid from './components/CategoryGrid';
import TimelineSection from './components/TimelineSection';
import RecommendGrid from './components/RecommendGrid';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import SubscribeSection from './components/SubscribeSection';

export default function Home() {
  usePageMeta({
    title: '看料大瓜 - 看料大瓜合集盘点｜热门事件汇总与高效补瓜指南',
    description:
      '看料大瓜合集盘点，一次性汇总近期最热门的瓜田事件与精华爆料，按时间线整理完整脉络，让你快速补课不掉队。吃瓜老手与新粉都适用的高效补瓜指南。',
    keywords: '看料大瓜,看料大瓜合集,看料大瓜盘点,看料大瓜汇总,吃瓜补课,热门事件',
    path: '/',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20theater%20stage%20with%20amber%20and%20crimson%20light%20beams%2C%20floating%20dust%20particles%2C%20deep%20shadowed%20background%2C%20artistic%20stylized%20cinematic%20composition%2C%20rich%20warm%20tones%2C%20moody%20atmosphere&width=1800&height=1100&seq=kldg-hero-main-01&orientation=landscape',
  });

  const homeFaqs = faqs.slice(0, 4);

  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '看料大瓜',
      url: 'https://kanliaodagua.example',
      description: '按时间线汇总娱乐热点话题与精华讨论的中文资讯站，提供高效补瓜指南。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://kanliaodagua.example/topics?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '看料大瓜',
      url: 'https://kanliaodagua.example',
      email: 'hello@kanliaodagua.example',
      description: '专注娱乐热点话题盘点与脉络梳理的内容团队。',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: homeFaqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ];

  return (
    <div id="top" className="min-h-screen bg-background-50">
      <JsonLd data={structuredData} />
      <SiteHeader transparentOnTop />
      <main>
        <HeroSection />
        <HeatRanking />
        <CategoryGrid />
        <TimelineSection />
        <RecommendGrid />
        <TestimonialSection />
        <FaqSection limit={4} />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}